import React from 'react';

import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';

export default function ErrorDialog(props) {

  const actions = [
    <FlatButton
      label='OK'
      primary={true}
      onClick={props.onClose} />
  ];

  return (
    <Dialog
      title={props.title || "Error"}
      open={props.open || true}
      onRequestClose={props.onClose}
      actions={actions}
      contentStyle={{maxWidth: '400px'}}
      modal={false}>

      <p>{props.message}</p>

    </Dialog>
  );
}


// WEBPACK FOOTER //
// ./src/components/ErrorDialog.js